module.exports = __webpack_public_path__ + "img/slice_put_one_elem_to_slice.8f803aeb.png";